import { Component, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CatId {
  id: number;
}

export interface BulkStatusData {
  id: number;
  categoryId: number;
  poisCount: number;
  status: string;
  message: string;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
}

@Component({
  selector: 'app-dialog-logs',
  templateUrl: './dialog-logs.component.html',
  styleUrls: ['./dialog-logs.component.css'],
  standalone: false,
})
export class DialogLogsComponent {
  subscriptionBulkStatusList: Subscription = new Subscription();
  content: BulkStatusData[] = [];
  subcription: Subscription = new Subscription();
  idCategory!: number;

  constructor(
    private subcategoryService: SubcategoryService,
    public route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: BulkStatusData[],
    public dialogRef: MatDialogRef<DialogLogsComponent>
  ) {}

  closeDialog() {
    this.dialogRef.close(false);
  }
}
